export default __webpack_public_path__ + "images/0ffecdd8abe048039c14b35d9cd2fbd8-denver_desktop.webp";